// bg color
export const VIEW_COLORS = {
    BG_COLOR: "#F5F6F8"
};
